<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Nt9zgf/tc-custom/9781504041157.jpg?1705894054249" alt="This image is the cover for the book King Solomon's Mines, Allan Quatermain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">King Solomon's Mines, Allan Quatermain
      </h1>
      <p class="bookDescription body article font2">
        <b>A famed elephant hunter embarks on a perilous African treasure hunt in this classic tale that launched the long-running Allan Quatermain series.</b><br/>  <br/> Sir Henry Curtis’s brother has disappeared into the uncharted African interior. Last seen by explorer and hunter Allan Quatermain, he was traveling toward the fabled King Solomon’s diamond mines in search of his fortune. Now, Curtis and his friend, Capt. John Good, persuade Quatermain and a mysterious native porter, Umbopa, to lead their expedition. They venture through treacherous mountain ranges and the valley of Kukuanaland, home to the violent Kukuana warriors, to find Curtis’s brother—and the treasure.<br/>  <br/> Journeying to an unexplored region of Africa, they encounter hardship, myth, lost tribes, cruel kings, and an evil sorceress. The three men also discover a secret about Umbopa that changes the course of their quest—and lands them in great danger. The team will need to keep their weapons—and their wits—handy if they hope to return home alive in this gripping tale full of exciting action and thrilling adventure.<br/>  <br/> Hailed by its publisher in 1885 as “the most amazing book ever written,” <i>King Solomon’s</i><i>Mines</i> was an immediate bestseller and, a century later, inspired the film starring Richard Chamberlain. Author H. Rider Haggard went on to write many more classic adventures featuring Quatermain, which continue to entertain audiences today.<br/><br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Rider Haggard
      </h2>
      
      <p class="authorDescription body article">H. Rider Haggard (1856&ndash;1925) was an English adventure novelist. Haggard studied law, but rather than pursuing a legal career took a secretarial position in what is now South Africa. His time there provided the inspiration for some of his most popular novels, including <I>She</I> (1887), an early classic of the lost world fantasy genre and one of the bestselling books of all time.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24c1ea7f